import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-how-we-do',
  templateUrl: './how-we-do.component.html',
  styleUrls: ['./how-we-do.component.scss'],
  standalone: false,
  animations: [
    trigger('numberAnimation', [
      transition(':increment', [
        style({ transform: 'translateY(20px)', opacity: 0 }),
        animate(
          '300ms ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
      transition(':decrement', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate(
          '300ms ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class HowWeDoComponent {
  selectedIndex = 0;
  readonly CARD_HEIGHT = 120;
  readonly CARD_GAP = 36;
  isBrowser: boolean = false;
  autoPlayInterval: any;
  items = [
    {
      icon: 'account_balance',
      color: 'green',
      title: 'Activate & Digitize your school',
      description:
        'Super Fast Onboarding with your existing data in less than 10 Mins',
      bgColor: 'rgba(87, 211, 131, 0.2)',
    },
    {
      icon: 'map',
      color: 'blue',
      title: 'Start tracking Performance Indicators',
      description:
        'View charts and reports that you need. All with a single click.',
      bgColor: 'rgba(58, 135, 254, 0.5)',
    },
    {
      icon: 'show_chart',
      color: 'yellow',
      title: 'Measure & Understand Data',
      description: 'Analyze day to day complex operations',
      bgColor: 'rgba(247, 211, 90, 0.5)',
    },
    {
      icon: 'trending_up',
      color: 'red',
      title: 'Improve Efficiency',
      description: 'Increase operational efficiency across departments.',
      bgColor: 'rgba(255, 149, 123, 0.5)',
    },
  ];
  originalItems = [...this.items];
  displayOrder: number[] = [0, 1, 2, 3];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.startAutoPlay();
  }

  startAutoPlay() {
    if (this.isBrowser) {
      this.autoPlayInterval = setInterval(() => {
        this.nextItem();
      }, 5000);
    }
  }

  nextItem(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
    this.reorderDisplayCards(this.selectedIndex);
  }

  // getCardTransform(index: number): string {
  //   const offset =
  //     (index - this.selectedIndex) * (this.CARD_HEIGHT + this.CARD_GAP);
  //   return `translateY(${offset}px)`;
  // }

  // selectItem(index: number): void {
  //   this.selectedIndex = index;
  // }

  getNumberStyle() {
    return {
      // color: this.items[this.selectedIndex].bgColor,
    };
  }

  selectItem(index: number): void {
    this.selectedIndex = index;

    this.reorderDisplayCards(index);

    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.startAutoPlay();
    }
  }

  reorderDisplayCards(startIndex: number): void {
    const newOrder: any = [];

    for (let i = 0; i < this.items.length; i++) {
      newOrder.push((startIndex + i) % this.items.length);
    }

    this.displayOrder = newOrder;
  }

  getCardTransform(index: number): string {
    const displayPosition = this.displayOrder.indexOf(index);
    const offset = displayPosition * (this.CARD_HEIGHT + this.CARD_GAP);
    return `translateY(${offset}px)`;
  }
}
